import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getProjectEmailData } from 'store/projectEmail/projectEmailSlice';
import { showEmailNotification } from 'utils/browserNotifications';

/**
 * Custom hook to handle email notifications
 * Listens to notifyEmailMessage from Redux and displays browser notifications
 */
export const useEmailNotifications = () => {
  const history = useHistory();
  const { notifyEmailMessage } = useSelector(getProjectEmailData);

  useEffect(() => {
    if (!notifyEmailMessage) return;

    // Only try to show notification if permission is already granted
    if (Notification.permission === 'granted') {
      showEmailNotification(notifyEmailMessage, () => {
        // Navigate to the email message
        const { projectKey, id } = notifyEmailMessage;
        if (projectKey && id) {
          history.push(`/project/${projectKey}/email?open=${id}`);
        }
        window.focus();
      });
    }
  }, [notifyEmailMessage, history]);
};
